import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

export default function DialogPopup({ open, closeDialogHandler, onClickModal, children, hideClose = false }) {

  const handleClose = () => {
    closeDialogHandler && closeDialogHandler(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      onClick={onClickModal ? onClickModal : () => { }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{"Immunie Alert"}</DialogTitle>
      <DialogContent>
        {children}
      </DialogContent>
      <DialogActions>
        {!hideClose && <Button onClick={handleClose} color="primary">
          Close
        </Button>}
      </DialogActions>
    </Dialog>
  );
}